/**
 * T.Z218 (contract v1.9.77) — the УНТИ exam vocabulary of #3/#18: the ONE display
 * fold of the mirror's own words, shared by the register and the export so the two
 * cannot drift (the `STATUS_RU_LABEL` rule, moved into `shared` because BOTH sides
 * of the wire read it).
 *
 * The raw fact is `unti_applications.difficulty_level` — the exam's difficulty level,
 * the УНТИ mirror's OWN lowercase literal (`elementary` / `advanced` seen live, ~5 890
 * rows filled on prod). Like every mirror column it is stored verbatim, never as an
 * enum on our side: a new word on their side must not need a migration (the `enrolled`
 * rule). The LABEL below is the RU reading a manager works from — «Базовый» /
 * «Повышенный» — and any value outside today's vocabulary prints AS IT IS, so their
 * drift reaches the screen and the sheet un-translated instead of silently blank.
 *
 * `null` / absent → `null` («—» on the screen, an empty cell in the file): the mirror
 * row the fold picked says nothing about the level, and guessing one would be a lie.
 */
/** The RU labels of the difficulty levels УНТИ names today, keyed by their literal. */
export const UNTI_DIFFICULTY_LABEL = {
    elementary: 'Базовый',
    advanced: 'Повышенный',
};
/**
 * The cell value of one `difficulty_level`: the RU label when the fold knows the
 * literal, the raw value (trimmed) when it does not, `null` when the mirror said
 * nothing — never a guessed level, never a blank for a word we simply have not
 * translated yet.
 */
export function untiDifficultyLabel(value) {
    if (value === null || value === undefined)
        return null;
    const trimmed = value.trim();
    if (trimmed === '')
        return null;
    return UNTI_DIFFICULTY_LABEL[trimmed] ?? trimmed;
}
//# sourceMappingURL=unti.js.map